
export class GetGroupingDataRequestModel {
  // グルーピングコード
  public groupingCode: string = <string>'';
}
